var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var birthdayBoxToProduct = function (birthdayBoxList, products) {
    if (!birthdayBoxList && products) {
        return products;
    }
    if (!products) {
        return [];
    }
    return birthdayBoxList.map(function (box) {
        var product = products.find(function (prod) { return prod.uuid === box.productId; });
        if (product) {
            return __assign(__assign(__assign({ label: box.title, value: box.productId }, product), box), { name: box.title });
        }
    });
};
